module.exports = __webpack_public_path__ + "static/media/banner1.09ba5c04.jpg";